import CanvaImport from '@core/lib/admin/components/canva_import'
import PropTypes from 'prop-types'
import React from 'react'

class CanvaImportWrapper extends React.Component {

  static propTypes = {
    onBack: PropTypes.func,
    onNext: PropTypes.func
  }

  _handleDone = this._handleDone.bind(this)

  render() {
    return <CanvaImport { ...this._getCanvaImport() } />
  }
  
  _getCanvaImport() {
    const { onBack } = this.props
    return {
      root: {
        id: null,
        image: '/images/services/canva.png',
        name: 'Canva'
      },
      onBack,
      onDone: this._handleDone
    }
  }

  _handleDone(canva_import) {
    const { assets, design } = canva_import
    this.props.onNext({
      title: design.name,
      thumbnail_id: assets[0].id,
      view_url: design.view_url.split('?')[0]
    })
  }

}

export default CanvaImportWrapper

